import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';

export class CaliforniaNotifyBeneficiariesInstructionsExportService extends ExportTypeBaseService {
  getFilename(): string {
    return `notify-beneficiaries-instructions.pdf`;
  }

  getSnackBarTitle(): string {
    return Lang.t('guidancestep.notify-beneficiaries-exporting');
  }
}
export default new CaliforniaNotifyBeneficiariesInstructionsExportService();
